import React from 'react';
import { Message } from '@messageformat/react';
import {
  Table,
  TableHead,
  TableHeaderCell,
  TableHeaderRow,
  Tile,
  TableRow,
  TableDataCell,
  TableBody,
  TableFooter,
  ScrollIndicator,
} from '@op/opds.opux';
import { space } from '@op/opds.tokens';
import TextComponent from '../TextComponent';
import { ReactComponent as Image003 } from '../../images/OP_symbolikuvitus_128_003.svg';
import { ReactComponent as ImageWithdrawal } from '../../images/symbol_banking_withdrawal_96.svg';
import { ReactComponent as ImagePayment } from '../../images/symbol_developer_corporate_payment_API_128.svg';

const TaxesSection = (): React.ReactElement => {
  return (
    <>
      <TextComponent messageId="course9.taxes.intro.body" twoColumns />
      <Image003 className="investoracademy-small-svg" aria-hidden="true" />
      <h2 className="investoracademy-title-hero">
        <Message id="course9.taxes.part1.title" />
      </h2>
      <TextComponent messageId="course9.taxes.part1.body" twoColumns headingAs="h3" />
      <ImageWithdrawal className="investoracademy-small-svg" aria-hidden="true" />
      <h2 className="investoracademy-title-hero">
        <Message id="course9.taxes.part2.title" />
      </h2>
      <TextComponent messageId="course9.taxes.part2.body" twoColumns />
      <ImagePayment className="investoracademy-small-svg" aria-hidden="true" />
      <h2 className="investoracademy-title-hero">
        <Message id="course9.taxes.part3.title" />
      </h2>
      <TextComponent messageId="course9.taxes.part3.body" twoColumns />
      <Tile style={{ marginTop: space.default }} wrapContent={false}>
        <div
          style={{ padding: `${space.default} ${space.default} 0`, textAlign: 'center' }}
        >
          <h3 className="investoracademy-general-graph-title">
            <Message id="course9.taxes.tile.title" />
          </h3>
          <p className="investoracademy-text-paragraph">
            <Message id="course9.taxes.tile.body1" />
          </p>
        </div>

        <ScrollIndicator>
          <Table>
            <TableHead>
              <TableHeaderRow>
                <TableHeaderCell scope="col">
                  <Message id="course9.taxes.table1.header.title" />
                </TableHeaderCell>
                <TableHeaderCell align="right" scope="col">
                  <Message id="course9.taxes.table1.header.column1" />
                </TableHeaderCell>
                <TableHeaderCell align="right" scope="col">
                  <Message id="course9.taxes.table1.header.column2" />
                </TableHeaderCell>
                <TableHeaderCell align="right" scope="col">
                  <Message id="course9.taxes.table1.header.column3" />
                </TableHeaderCell>
              </TableHeaderRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableHeaderCell scope="row">
                  <Message id="course9.taxes.table1.row1.title" />
                </TableHeaderCell>
                <TableDataCell align="right">
                  <Message id="course9.taxes.table1.row1.column1" />
                </TableDataCell>
                <TableDataCell align="right">
                  <Message id="course9.taxes.table1.row1.column2" />
                </TableDataCell>
                <TableDataCell align="right">
                  <Message id="course9.taxes.table1.row1.column3" />
                </TableDataCell>
              </TableRow>
              <TableRow>
                <TableHeaderCell scope="row">
                  <Message id="course9.taxes.table1.row2.title" />
                </TableHeaderCell>
                <TableDataCell align="right">
                  <Message id="course9.taxes.table1.row2.column1" />
                </TableDataCell>
                <TableDataCell align="right">
                  <Message id="course9.taxes.table1.row2.column2" />
                </TableDataCell>
                <TableDataCell align="right">
                  <Message id="course9.taxes.table1.row2.column3" />
                </TableDataCell>
              </TableRow>
            </TableBody>
            <TableFooter>
              <TableRow>
                <TableHeaderCell scope="row">
                  <Message id="course9.taxes.table1.footer.title" />
                </TableHeaderCell>
                <TableDataCell align="right">
                  <Message id="course9.taxes.table1.footer.column1" />
                </TableDataCell>
                <TableDataCell align="right">
                  <Message id="course9.taxes.table1.footer.column2" />
                </TableDataCell>
                <TableDataCell align="right">
                  <Message id="course9.taxes.table1.footer.column3" />
                </TableDataCell>
              </TableRow>
            </TableFooter>
          </Table>
        </ScrollIndicator>
        <div style={{ padding: `${space.default} ${space.default} 0` }}>
          <p className="investoracademy-text-paragraph">
            <Message id="course9.taxes.tile.body2" />
          </p>
          <p className="investoracademy-text-paragraph">
            <Message id="course9.taxes.tile.body3" />
          </p>
        </div>
      </Tile>
      <h3 className="investoracademy-title-paragraph investoracademy-centered-and-padding-default-text">
        <Message id="course9.taxes.part4.title" />
      </h3>
      <TextComponent messageId="course9.taxes.part4.body" twoColumns />
    </>
  );
};

export default TaxesSection;
